import { z } from 'zod';
/**
 * Bejelentkezett eszkoz (munkamenet) - a Beallitasok es az admin listajahoz.
 *
 * Az IP es a bongeszo-azonosito csak felismeresre szol ("ez a laptopom"), nem
 * hitelesitesre.
 */
export const deviceSessionSchema = z.object({
    id: z.string(),
    client: z.string(),
    /** `password` vagy `entra` (Microsoft-fiok). */
    method: z.string(),
    userAgent: z.string().nullable(),
    ip: z.string().nullable(),
    createdAt: z.string(),
    lastSeenAt: z.string(),
    /** Ez a mostani eszkoz - azt nem lehet innen kileptetni, arra a Kilepes valo. */
    current: z.boolean(),
});
/**
 * Rovid, emberi nev a bongeszo-azonositobol: "Chrome · Windows".
 *
 * Szandekosan egyszeru: nem kell pontos, csak annyi, hogy a felhasznalo
 * raismerjen a sajat gepere.
 */
export function describeUserAgent(userAgent, client) {
    if (client === 'desktop')
        return 'Asztali alkalmazás';
    if (!userAgent)
        return 'Ismeretlen eszköz';
    const browser = /Edg\//.test(userAgent)
        ? 'Edge'
        : /Firefox\//.test(userAgent)
            ? 'Firefox'
            : /Chrome\//.test(userAgent)
                ? 'Chrome'
                : /Safari\//.test(userAgent)
                    ? 'Safari'
                    : 'Böngésző';
    const os = /iPhone|iPad/.test(userAgent)
        ? 'iOS'
        : /Android/.test(userAgent)
            ? 'Android'
            : /Windows/.test(userAgent)
                ? 'Windows'
                : /Mac OS X/.test(userAgent)
                    ? 'macOS'
                    : /Linux/.test(userAgent)
                        ? 'Linux'
                        : '';
    return os ? `${browser} · ${os}` : browser;
}
//# sourceMappingURL=session.js.map